import DOMPurify from 'dompurify';
import { Operation } from 'operations/operation';

export interface ChatErrorMessageBubbleProps {
    error?: string;
    question: string;
    // Matches ChatMessageBubble's `onNewMessage`, which is what gets bound here:
    // the operation is the SECOND argument, not the third.
    retry: (message: string, operation?: Operation) => void;
    helpCenterUrl?: string;
    metadata?: any;
    operation?: Operation;
}

export const ChatErrorMessageBubble = (props: ChatErrorMessageBubbleProps) => {
    const { error = 'An error occurred. Either the engine you requested does not exist or there was another issue processing your request. If this issue persists please contact us through our help center at help.har.com', question, retry, operation } = props;

    // Sanitize error content to prevent XSS
    const sanitizedErrorHtml = DOMPurify.sanitize(error, {
        ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'br', 'span'],
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
    });

    return (
        <div className="chatbot_bubble">
            <div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/a_all/chat_ai_icon2.svg" /></div>
            <div className="chatbot_bubble__text">
                <div className='error_small'>
                    <div className='error_small__icon'><img className='w-16px' src="https://content.harstatic.com/media/icons/a_all/alert_oval_red.svg" /></div>
                    <div className='error_small__text' dangerouslySetInnerHTML={{ __html: sanitizedErrorHtml }}></div>
                    <div className='error_small__refresh'>
                        <span onClick={() => retry(question, operation)} className='btn btn--shapeless d-flex' style={{ cursor: "pointer" }}>
                            <div className='mr-2'><img src="https://content.harstatic.com/media/icons/refresh_icon.svg" /></div>
                            <div>Retry</div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}
